

// Api接口获取
import * as api from '../api/api';
import md5 from 'js-md5'
// Axios获取专栏信息
const msg = api.getChannel()
// 获取秒杀数据
export const loadSeckillsInfo = ({ commit }) => {
  return new Promise((resolve, reject) => {
    const data = [
      {
        intro: '【赠小风扇】维他 柠檬茶250ml*32盒 礼品装 整箱',
        img: 'static/img/index/seckill/seckill-item1.jpg',
        price: 71.9,
        realPrice: 89.6
      },
      {
        intro: 'Kindle Paperwhite 全新升级版6英寸护眼非反光电子墨水',
        img: 'static/img/index/seckill/seckill-item2.jpg',
        price: 989.0,
        realPrice: 1299.0
      },
      {
        intro: '粮悦 大吃兄糯米锅巴 安徽特产锅巴糯米原味400g*2盒',
        img: 'static/img/index/seckill/seckill-item3.jpg',
        price: 21.8,
        realPrice: 49.0
      },
      {
        intro: '【京东超市】清风（APP）抽纸 原木纯品金装系列 3层',
        img: 'static/img/index/seckill/seckill-item4.jpg',
        price: 49.9,
        realPrice: 59.0
      },
      {
        intro: 'NIKE耐克 男子休闲鞋 AIR MAX 90 ESSENTIAL 气垫',
        img: 'static/img/index/seckill/seckill-item5.jpg',
        price: 559.9,
        realPrice: 759.9
      }
    ];
    const date = new Date();
    const hours = date.getHours();
    const minute = date.getMinutes();
    const seconds = date.getSeconds();
    // 距离开始秒杀时间
    const deadline = {
      hours: 1,
      minute: 38,
      seconds: 36
    };
    commit('SET_SECKILLS_INFO', [data, deadline]);
  });
};

// 获取轮播(营销)图片
export const loadCarouselItems = ({ commit }) => {
  return new Promise((resolve, reject) => {
    api.getBanner().then(data => {
      commit('SET_CAROUSELITEMS_INFO', data);
    });
  });
};

// 加载电脑专栏数据,commit传值到mutations.js
export const loadComputer = ({ commit }) => {
  return new Promise((resolve, reject) => {
    msg.then(value => {
      commit('SET_COMPUTER_INFO', value[0]);
    });
  });
};

// 加载爱吃专栏数据
export const loadEat = ({ commit }) => {
  return new Promise((resolve, reject) => {
    msg.then(value => {
      commit('SET_EAT_INFO', value[1]);
    });
  });
};

// 请求获得商品详细信息
export const loadGoodsInfo = ({ commit },sku) => {
  commit('SET_LOAD_STATUS', true);
  return new Promise((resolve, reject) => {
    setTimeout(() => {
      api.getDetails(sku).then(value => {
        // console.log(value.result)
        commit('SET_GOODS_INFO', value.result);
        commit('SET_LOAD_STATUS', false);
      });
    }, 300);
  });
};

// 获取商品列表
export const loadGoodsList = ({ commit }, search) => {
  commit('SET_LOAD_STATUS', true);
  return new Promise((resolve, reject) => {
    setTimeout(() => {
      api.getSearch(search).then(value => {
        commit('SET_GOODS_LIST', value);
        commit('SET_LOAD_STATUS', false);
      });
    });
  });
};

// 添加购物车
export const addShoppingCart = ({ commit }, data) => {
  return new Promise((resolve, reject) => {
    api.addToCart(data.addCar).then(msg => {
      if(msg.msg === 'success')
        return data.addCar.partner_id
    }).then(partner_id => {
      api.getShopCar(partner_id).then(value => {
        commit('SET_SHOPPING_CART', value.result)
      })
    })
    commit('ADD_SHOPPING_CART', data.shopping);
  });
};

// 获取用户推荐
export const loadRecommend = ({ commit }) => {
  return new Promise((resolve, reject) => {
    const data = [
      [
        {
          img: 'static/img/otherBuy/1.jpg',
          intro: 'iPhone7/6s/8钢化膜苹果7Plus全屏全覆盖3D抗蓝',
          price: 29.00
        },
        {
          img: 'static/img/otherBuy/2.jpg',
          intro: '苹果数据线 苹果iPhoneX/6s/7plus/8充电线',
          price: 36.00
        },
        {
          img: 'static/img/otherBuy/3.jpg',
          intro: '苹果8/7/6/6s钢化膜 iphone8/7/6s/6钢化玻璃',
          price: 19.00
        },
        {
          img: 'static/img/otherBuy/4.jpg',
          intro: 'iPhone6s/7钢化膜苹果8 Plus手机膜抗蓝光非全屏',
          price: 28.00
        }
      ],
      [
        {
          img: 'static/img/otherBuy/5.jpg',
          intro: '苹果6s手机壳iPhone6s Plus保护壳防摔全',
          price: 28.00
        },
        {
          img: 'static/img/otherBuy/6.jpg',
          intro: 'iPhone7/8手机壳手机套防摔磨砂保护壳星空黑☆全包保护',
          price: 30.00
        },
        {
          img: 'static/img/otherBuy/7.jpg',
          intro: '数据线 适用于苹果iPhone 6s/6plus/7plus/8/X',
          price: 18.00
        },
        {
          img: 'static/img/otherBuy/8.jpg',
          intro: 'iPhone8/7/6S/6钢化膜 苹果8/7/6s/6玻璃膜 手机高',
          price: 15.00
        }
      ]
    ];
    commit('SET_RECOMMEND_INFO', data);
  });
};

// 获取地址缓存
export const loadAddress = ({ commit }, user_id) => {
  return new Promise((resolve, reject) => {
    api.getShopAddress(user_id).then(data => {
      commit('SET_USER_ADDRESS', data.result);
    })
  });
};

// 获取购物车缓存
export const loadShoppingCart = ({ commit },partner_id) => {
  return new Promise((resolve, reject) => {
    api.getShopCar(partner_id).then(data => {
      commit('SET_SHOPPING_CART',data.result)
    })

  });
};

//获取购物订单缓存
export const loadShoppingOrder = ({ commit },partner_id) => {
  return new Promise((resolve, reject) => {
    api.getShopOrder(partner_id).then(data => {
      commit('SET_SHOPPING_ORDER',data.result)
    })
  });
};

// 用户下单
export const pushOrder = ({ commit },data) => {
  return new Promise((resolve, reject) => {
    api.createOrder(data).then(value => {
      resolve(value.result)
      return value.result
      // commit('SET_MONEY',value.result)
    })
  });
};

// 检测订单支付结果
export const selectOrder = ({ commit },data) => {
  return new Promise((resolve, reject) => {
    api.getOrder(data).then(value => {
      resolve(value.result)
      return value.result
      // commit('SET_STATUS',value.result)
    })
  });
};

// 添加注册用户
export const addSignUpUser = ({ commit }, data) => {
  return new Promise((resolve, reject) => {
    api.toRegister(data).then(msg => {
      return msg.result
    }).then(value => {
      if(value.state === 'failed') reject(value.msg)
      else{
        resolve('成功')
      }
    })
  });
};

// 获取手机验证码
export const getAccessCode = ({ commit }, data) => {
  return new Promise((resolve, reject) => {
    api.getAccessCode(data).then(msg => {
      return msg.result
    }).then(value => {
      if(value.state != 'success') reject(value.msg)
      else{
        resolve('成功')
      }
    })
  });
};

// 用户登录
export const login = ({ commit }, data) => {
  return new Promise((resolve, reject) => {
    data.password = md5(data.password)
    api.toLogin(data).then(value => {
      if(value.state != 'failed'){
        localStorage.setItem('loginInfo', JSON.stringify(value.result));
        commit('SET_USER_LOGIN_INFO', value.result);
        resolve(true);
      } else {
        resolve(false);
      }

    })

  });
};

// 用户登录
// export const login = ({ commit }, data) => {
//   return new Promise((resolve, reject) => {
//     if (data.username === 'Gavin' && data.password === '123456') {
//       localStorage.setItem('loginInfo', JSON.stringify(data));
//       commit('SET_USER_LOGIN_INFO', data);
//       resolve(true);
//       return true;
//     }
//     const userArr = localStorage.getItem('users');
//     if (userArr) {
//       const users = JSON.parse(userArr);
//       for (const item of users) {
//         if (item.username === data.username) {
//           localStorage.setItem('loginInfo', JSON.stringify(item));
//           commit('SET_USER_LOGIN_INFO', item);
//           resolve(true);
//           break;
//         }
//       }
//     } else {
//       resolve(false);
//     }
//   });
// };

// 退出登陆
export const signOut = ({ commit }) => {
  localStorage.removeItem('loginInfo');
  commit('SET_USER_LOGIN_INFO', {});
};

// 判断是否登陆
export const isLogin = ({ commit }) => {
  const user = JSON.parse(localStorage.getItem('loginInfo'));
  if (user) {
    commit('SET_USER_LOGIN_INFO', user);
    api.getShopCar(user.partner_id).then(value => {
      commit('SET_SHOPPING_CART', value.result)
    })
    api.getShopAddress(user.user_id).then(data => {
      commit('SET_USER_ADDRESS', data.result);
    })
    api.getShopInvoice(user.user_id).then(data => {
      commit('SET_USER_INVOICE', data.result);
    })
  }
};

// sign计算
export const sign = ({ commit }) => {
  return new Promise((resolve, reject) => {
    commit('SET_SIGN', 1);
  });
};

// 首页商品列表
export const loadGoods = ({ commit }) => {
  return new Promise((resolve, reject) => {
    api.getGoodsList().then(data => {
      resolve(data);
    });
  });
};

// 修改用户密码
export const resetPassword = ({ commit }, data) => {
  return new Promise((resolve, reject) => {
    data.password = md5(data.password);
    api.resetPassword(data).then(msg => {
      return msg.result;
    }).then(value => {
      if (value.state === 'failed') reject(value.msg);
      else {
        resolve('成功');
      }
    });
  });
};

// 修改用户收货地址
export const updateAddress = ({ commit }, data) => {
  return new Promise((resolve, reject) => {
    api.updateAddress(data).then(msg => {
      return msg;
    }).then(value => {
      if (value.state === 'failed') reject(value.msg);
      else {
        resolve('成功');
      }
    });
  });
};

// 获取地址缓存
export const loadInvoice = ({ commit }, user_id) => {
  return new Promise((resolve, reject) => {
    api.getShopInvoice(user_id).then(data => {
      commit('SET_USER_INVOICE', data.result);
    })
  });
};

// 修改用户收货地址
export const updateInvoice = ({ commit }, data) => {
  return new Promise((resolve, reject) => {
    api.updateInvoice(data).then(msg => {
      return msg;
    }).then(value => {
      if (value.state === 'failed') reject(value.msg);
      else {
        resolve('成功');
      }
    });
  });
};



// WEBPACK FOOTER //
// ./src/vuex/actions.js